import React from "react";
import { Link } from "react-router-dom";

const PageHeader = ({ title, breadcrumbs, image }) => {
    return (
        <div
            className="container-fluid bg-breadcrumb"
            style={{
                background: `linear-gradient(#00000099, #00bcd43b) center center / cover no-repeat fixed, url(${image})`,
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                // backgroundAttachment: 'fixed',
                backgroundRepeat: 'no-repeat',
            }}
        >

            <div className="container text-center py-5" style={{ maxWidth: 900 }}>
                <h3 className="text-white display-3 mb-4">{title}</h3>
                <ol className="breadcrumb justify-content-center mb-0">
                    <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                    </li>
                    {breadcrumbs.map((crumb, index) => (
                        <li
                            key={index}
                            className={`breadcrumb-item ${crumb.active ? "active text-white" : ""
                                }`}
                            aria-current={crumb.active ? "page" : undefined}
                        >
                            {crumb.active ? (
                                crumb.label
                            ) : (
                                <Link to={crumb.path}>{crumb.label}</Link>
                            )}
                        </li>
                    ))}
                </ol>
            </div>
        </div>
    );
};

export default PageHeader;
